module.exports = __webpack_public_path__ + "static/media/add-order-btn.0309a96f.svg";